import { Backdrop, CircularProgress } from '@mui/material'

interface Props {
  open: boolean
}

export default function Loading(props: Props) {
  return (
    <Backdrop
      id="loading"
      sx={{
        color: 'common.white',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={props.open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}
